
import { For, createEffect, createMemo, createSignal } from 'solid-js'
import { AgentDocumentReferenceEvent, AgentTicketReferenceEvent, parseTrace, requireSuppportAssistAgentContext } from '../SupportAssistAgentContext'
import styles from '../st-support-assist-agent.module.css'

export function References() {
    const context = requireSuppportAssistAgentContext();

    const references = createMemo(() => {
        const traces = context.conversation.messages.flatMap(m => m.traces);
        const filtered = traces.filter(t => t.type === 'agent.document_reference' || t.type === 'agent.ticket_reference');
        const events = filtered.map(parseTrace) as (AgentDocumentReferenceEvent | AgentTicketReferenceEvent)[];
        return events;
    })

    createEffect(() => {
        console.log('References: ', [...references()])
        context.setReferencesVisible(references().length > 0);
    })

    return (
        <div class={styles['references-list']}>
            <For each={references()}>{reference => (
                <Reference reference={reference} />
            )}</For>
        </div>
    )
}

function Reference(props: { reference: AgentDocumentReferenceEvent | AgentTicketReferenceEvent }) {
    const [expanded, setExpanded] = createSignal(false);

    const title = createMemo(() => {
        if (props.reference.type === 'agent.document_reference') {
            return props.reference.filename;
        } else {
            return props.reference.ticketNumber;
        }
    });

    const content = createMemo(() => props.reference.content || '');

    return (
        <div class={styles['reference']} data-expanded={expanded()} onClick={() => setExpanded(!expanded())}>
            <a class={styles['reference-title']}>{title()}</a>
            <div class={styles['reference-content']}>
                {content()}
            </div>
        </div>
    )
}
